export const OVERVIEW_VIEW_TRANSLATION_DE = {
  details: 'Auftragsdetails',
  appointments: 'Termine',
} as const;
